import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow1Left = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 13.937 23.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.918,23.910 C12.678,23.910 12.438,23.824 12.247,23.648 L0.330,12.695 C0.125,12.507 0.007,12.240 0.007,11.961 C0.007,11.682 0.125,11.416 0.330,11.227 L12.247,0.274 C12.652,-0.098 13.281,-0.070 13.651,0.335 C14.021,0.740 13.994,1.370 13.590,1.742 L2.471,11.961 L13.590,22.181 C13.994,22.552 14.021,23.182 13.651,23.588 C13.455,23.802 13.187,23.910 12.918,23.910 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow1Left.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
